import { useEffect, useRef } from 'react';
import * as Sentry from '@sentry/browser';

import { useVoip } from '$app-web/components/chat/state/chat-client.state';

import { CALL_VIEW_MODES, CallViewChangedPayload, CallViewMode } from './types';

type ReportCallView = (payload: CallViewChangedPayload) => void;

interface VoipState {
    isMinimized?: boolean;
    activeCallData?: { id?: string };
}

export function useCallViewReporter(report: ReportCallView) {
    const voip = useVoip() as VoipState;
    const activeCallId = voip?.activeCallData?.id || null;
    const mode: CallViewMode = voip?.isMinimized ? CALL_VIEW_MODES.MINIMIZED : CALL_VIEW_MODES.FULLSCREEN;

    const lastReportedRef = useRef<CallViewMode | null>(null);

    useEffect(() => {
        if (activeCallId === null) {
            lastReportedRef.current = null;
            return;
        }

        if (lastReportedRef.current === mode) {
            return;
        }

        try {
            report({ mode });
            lastReportedRef.current = mode;
        } catch (error) {
            Sentry.withScope((scope) => {
                scope.setTag('catch_in', 'useCallViewReporter');
                scope.setExtras({ mode, callId: activeCallId });
                Sentry.captureException(error);
            });
        }
    }, [mode, activeCallId, report]);
}
